<template>
  <div id="projects-map" style="height: 600px"></div>
  <!--<div class="debug">
    <p>points.length = {{ points.length }}</p>
    <p>points[0] = {{ points[0] }}</p>
  </div>-->
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from 'vue'
import '@/../node_modules/leaflet/dist/leaflet.css'
import L from 'leaflet'
import { useProjectStore } from '@/stores'
import { storeToRefs } from 'pinia'
const projects = useProjectStore()
const { allProjects } = storeToRefs(projects);
const points = ref(allProjects)
//points.value = await projects.getAll()

const DOMAIN = 'https://smp.midspan.work';
//const DOMAIN = 'http://localhost:8080';
/*
const props = defineProps<{
  points: Array<any>,
}>();*/
/*
const props = defineProps<{
  points: Array<any>,
}>();*/
const blueFlag = L.icon({
  iconUrl: '/blue-flag-solid.svg',
  iconSize: [24, 24],
  iconAnchor: [0, 24],
  popupAnchor: [0, -24],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null
})

const coordinates = [51, -95]
const zoom = 4

//return array
/*const gps = computed(()=>{
    //return {'lat' : props.lat, 'lng' : props.lon}
    return props.gpsStr.split(',');
});*/

onMounted(async () => {
  console.log('My-map.vue mounted...')
  let map = L.map('projects-map', { scrollWheelZoom: false, preferCanvas: true }).setView(coordinates, zoom)

  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }).addTo(map)

  console.log('attempting to add all points ...')
  //loop through all points and create a marker with popups

  points.value.forEach(async (point) => {
    try {
      //console.log('point id :' + point.id)
      //get gpsArr from string
      let gpsArr = [point.gps.lat, point.gps.lon]

      //add marker
      let marker = await L.marker(gpsArr, { icon: blueFlag}).addTo(map)

      //add popup to marker
      //marker.bindPopup("<button :onclick='clicked'>point.projectName</button>");
      //marker.bindPopup('<button onclick="clicked()">click</button>');
      marker.bindPopup(
        `<b>${point.id}</b><br><a href="${DOMAIN}/projects/${point.id}/details">${point.name}</a>`
      )
      /*marker.bindPopup(
        `'<a href="http://192.168.50.81:8080/projects/${point.id}/details">1${point.projectName}</a>'`
      )*/
    } catch (error) {
      console.error("..trapped error creating map marker for point : " + JSON.stringify(point));
    }
  })

  //map.update()
})
</script>

<script lang="ts">
function clicked() {
  console.log('clicked')
}
</script>
